import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { EARLY_ACCESS_PILOT_LABEL } from '@/lib/earlyAccessPilot';

type EarlyAccessPilotBadgeProps = {
  className?: string;
};

const EarlyAccessPilotBadge: React.FC<EarlyAccessPilotBadgeProps> = ({ className }) => {
  const badgeClassName =
    'border-amber-200/30 bg-amber-300/12 text-amber-100 shadow-[0_12px_30px_rgba(0,0,0,0.28)] backdrop-blur-md';

  return (
    <Badge className={cn(badgeClassName, className)}>
      {EARLY_ACCESS_PILOT_LABEL}
    </Badge>
  );
};

export default EarlyAccessPilotBadge;
